/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Row, Cell } from 'react-table';

import { Tooltip } from '../..';
import { TooltipColumn } from '../types';
import { defaultCellWidth, defaultTooltipPosition } from '../constants';

interface NumberedItemCellProps<D extends object> {
    row: Row<D>;
    cell: Cell<D>;
    column: TooltipColumn<D>;
}

/**
 * Renders a numbered item from a cell.value and the row.index, using a tooltip and truncating the
 * value with an ellipses if it goes past 2 lines.
 * Be aware that the row.index refers to the original index (pre-sorting), so you may need to sort
 * the data before you pass it into a table if you are setting the table up with an initial state
 * that is sorted. See EntityManagerTable for an example of this.
 * @param param0
 */
export function NumberedItemCell<D extends object>({
    row,
    cell,
    column,
}: NumberedItemCellProps<D>): JSX.Element {
    const position = column?.tooltipPosition ?? defaultTooltipPosition;
    const width = (column?.width as number) ?? defaultCellWidth;

    return (
        <Tooltip message={cell.value} position={position}>
            <div className="flex items-center">
                <div
                    className="respond-to-mouse leading-tight clamp-2-lines"
                    style={{
                        width,
                    }}
                >
                    {`${row.index + 1}. ${cell.value}`}
                </div>
            </div>
        </Tooltip>
    );
}
